import { render } from "./App.vue?vue&type=template&id=0302cb91"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0302cb91&lang=css"

import exportComponent from "/home/rocky/dialogue_game2/dialogue_game/website/enmusubi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__